import { SearchPlatform } from './types'

interface AddQueryFormProps {
  formData: { name: string; search_url: string; platform: SearchPlatform }
  setFormData: React.Dispatch<React.SetStateAction<{ name: string; search_url: string; platform: SearchPlatform }>>
  handleAddQuery: (e: React.FormEvent) => Promise<void>
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export function AddQueryForm({
  formData,
  setFormData,
  handleAddQuery,
  setIsDrawerOpen,
}: AddQueryFormProps) {
  return (
    <form onSubmit={handleAddQuery} className="space-y-4">
      <div>
        <label htmlFor="query-name-form" className="block text-small text-text-secondary mb-1">
          Query Name *
        </label>
        <input
          id="query-name-form"
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="w-full px-3 py-2 border border-border-strong rounded-lg focus:ring-2 focus:ring-interactive-focus-ring focus:border-interactive bg-surface-default text-text-primary"
          placeholder="e.g., Senior React Developer"
          required
        />
      </div>
      <div>
        <label htmlFor="search-url-form" className="block text-small text-text-secondary mb-1">
          Search URL *
        </label>
        <input
          id="search-url-form"
          type="url"
          value={formData.search_url}
          onChange={(e) => setFormData({ ...formData, search_url: e.target.value })}
          className="w-full px-3 py-2 border border-border-strong rounded-lg focus:ring-2 focus:ring-interactive-focus-ring focus:border-interactive bg-surface-default text-text-primary"
          placeholder="https://www.linkedin.com/jobs/search/..."
          required
        />
        <p className="mt-1 text-sm text-text-muted">
          Copy the full URL from your browser when viewing search results
        </p>
      </div>
      <div>
        <label htmlFor="platform" className="block text-small text-text-secondary mb-1">
          Platform *
        </label>
        <select
          id="platform"
          value={formData.platform}
          onChange={(e) => setFormData({ ...formData, platform: e.target.value as SearchPlatform })}
          className="w-full px-3 py-2 border border-border-strong rounded-lg focus:ring-2 focus:ring-interactive-focus-ring focus:border-interactive bg-surface-default text-text-primary"
        >
          <option value="linkedin">LinkedIn</option>
          <option value="indeed">Indeed</option>
          <option value="glassdoor">Glassdoor</option>
        </select>
      </div>
      <div className="flex gap-2 pt-4">
        <button
          type="submit"
          className="px-4 py-2 bg-brand-primary text-text-inverse rounded-lg hover:bg-brand-primary-hover transition-colors"
        >
          Add Query
        </button>
        <button
          type="button"
          onClick={() => {
            setIsDrawerOpen(false)
            setFormData({ name: '', search_url: '', platform: 'linkedin' })
          }}
          className="px-4 py-2 bg-surface-muted text-text-secondary rounded-lg hover:bg-surface-subtle transition-colors min-h-11"
        >
          Cancel
        </button>
      </div>
    </form>
  )
}
